import { SplitDirection } from "./index76.js";
import { getPolygonArea, smallestBBox } from "@project-rouge/rg-three";
function isValidSubdivision({ polygon, splitOption, minWidth, maxLength, minArea, rng, count, maxCount, splitLikelihood = .5 }) {
	const bBox = smallestBBox(polygon);
	const currentArea = getPolygonArea(polygon);
	const minFactor = splitOption.minFactor;
	const maxEdgeLength = bBox.maxSides[0].length;
	const minEdgeLength = bBox.minSides[0].length;
	if (count + 1 > maxCount) return false;
	if (checkMinWidth({
		splitOption,
		maxEdgeLength,
		minEdgeLength,
		minFactor,
		minWidth
	})) return false;
	const isTooLong = maxEdgeLength > maxLength;
	if (isTooLong && splitOption.direction === SplitDirection.transverse) return true;
	if (isTooLong && splitOption.direction === SplitDirection.longitudinal) return false;
	if (currentArea * minFactor < minArea) return false;
	if (rng) return rng() < splitLikelihood;
	else return true;
}
function checkMinWidth({ splitOption, maxEdgeLength, minEdgeLength, minFactor, minWidth }) {
	let isMinWidthViolated = false;
	if (splitOption.direction === SplitDirection.transverse) isMinWidthViolated = maxEdgeLength * minFactor < minWidth;
	else isMinWidthViolated = minEdgeLength * minFactor < minWidth;
	return isMinWidthViolated;
}
export { isValidSubdivision };

//# sourceMappingURL=index75.js.map